const SERVICE = 'shipment'
export const SHIPMENT_SUBMIT = `${SERVICE}-submit`
export const BOL_PARSE_SUCCESS = `${SERVICE}-bol-parse-success`
export const BOL_PARSE_FAIL = `${SERVICE}-bol-parse-fail`
export const CONTAINER_FOUND = `${SERVICE}-container-found`
export const CONTAINER_NOT_FOUND = `${SERVICE}-container-not-found`
